var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow-icon",class:'arrow-icon--' + _vm.direction},[_c('img',{staticClass:"arrow-icon__image",attrs:{"src":require('@/assets/arrow.svg'),"alt":"Arrow Icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }